
import { v4 as uuid } from 'uuid';

export const ADD_OR_UPDATE_LINE_ITEM = 'mallfront/address/ADD_OR_UPDATE_LINE_ITEM';
export const SAVE_LINE_ITEM = 'mallfront/address/SAVE_LINE_ITEM';
export const REMOVE_LINE_ITEM = 'mallfront/address/REMOVE_LINE_ITEM';
export const CLEAR_LINE_ITEMS = 'mallfront/address/CLEAR_LINE_ITEMS';

const initialState = {};


export const lineItemReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_OR_UPDATE_LINE_ITEM: {
            const uid = action.lineItem.id || uuid();
            return {
                ...state,
                [uid]: { ...action.lineItem, id: uid }
            };
        }
        case REMOVE_LINE_ITEM: {
            const { [action.lineItem.id]: value, ...remainder } = state;
            return remainder;
        }
        case CLEAR_LINE_ITEMS: {
            return {};
        }
        default:
            return state;
    }
};

export const addOrUpdateLineItem = lineItem => ({
    type: ADD_OR_UPDATE_LINE_ITEM,
    lineItem
});

export const removeLineItem = lineItem => ({
    type: REMOVE_LINE_ITEM,
    lineItem
});

export const clearLineItems = () => ({
    type: CLEAR_LINE_ITEMS
});

export const saveLineItem = lineItem => ({
    type: SAVE_LINE_ITEM,
    lineItem
});
